import { Fragment, ReactElement } from 'react';
import Breadcrumbs, { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import FamilyShared from 'subscription/pages/registration-birth-family/search';

interface ResearchFamilyNotificationsSharedProps {
  goBackUrl?: string;
  redirectUrl?: string;
  items?: BreadcrumbItem[];
}

const ResearchFamilyNotificationsShared = ({
  goBackUrl = '',
  redirectUrl = '',
  items = [],
}: ResearchFamilyNotificationsSharedProps): ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={items} />
      <FamilyShared isWithoutBreadcrumbs goBackUrl={goBackUrl} pathname={redirectUrl} />
    </Fragment>
  );
};

ResearchFamilyNotificationsShared.displayName = 'Research Family Notifications Shared component';

export default ResearchFamilyNotificationsShared;
